import moment from 'moment';
import Promise from 'bluebird';

import {
    PROPOSAL_ERROR,
    PROPOSAL_CLEAR,
    PROPOSAL_RETRIEVED,
    PROPOSAL_BUSY,
    PROPOSAL_CREATED,
    PROPOSAL_SAVED,
    PROPOSAL_LIST_RETRIEVED,
    PROPOSAL_DELETED,
    EMAIL_ERROR,
    TIL_BEHANDLING_STATUS,
    PROPOSAL_FILE_ADDED,
    PROPOSAL_FILE_DELETE,
} from '../constants/actions';
import {respToJson} from '../utils/fetching';

import {
    addExecuteQuery,
    getList,
    getItem,
    deleteItem,
    uploadListItemFile,
    deleteListItemFile,
    getAvatarUrlByEmail,
} from 'ntnu-react/util/sp';
import { calculateAverages } from '../utils/calc';



const statusCodeMap = {
    "Under utfylling": "0",
    "Til behandling": "1",
    "Under behandling": "2",
    "Ferdig behandlet": "3",
};

const PROPOSAL_STATUS_FIELD_NAME = 'Status1';
const TIL_BEHANDLING_CODE = 'Under behandling';

export function deleteProposal(id) {
    return (dispatch) => {
        dispatch({type: PROPOSAL_BUSY});
        if (__DEV__) {
            return dispatch({
                type: PROPOSAL_DELETED,
                payload: id,
            });
        }
        deleteItem('Endringsforslag', id)
        .then((id) => {
            return dispatch({
                type: PROPOSAL_DELETED,
                payload: id,
            });
        });
    };
}

export function saveFiles(id, files) {
    return (dispatch) => {
        Promise.mapSeries(files, (file) => {
            // try to delay a bit to avoid SP going into zoidberg-mode
            return Promise.delay(100).then(() => {
                return uploadListItemFile('Endringsforslag', id, file)
                .then(() => {
                    dispatch({
                        type: PROPOSAL_FILE_ADDED,
                        payload: file.name,
                    });
                    return file.name;
                })
                .catch(() => null);
            });
        })
        .catch((err) => {
            console.error(err);
        });
    };
}

export function deleteFile(id, filename) {
    return (dispatch) => {
        deleteListItemFile('Endringsforslag', id, filename)
        .then(() => {
            dispatch({
                type: PROPOSAL_FILE_DELETE,
                payload: filename,
            });
        })
        .catch((err) => {
            console.error(err);
        });
    };
}

export function saveProposalData(proposal) {
    let returnType = '';
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({type: PROPOSAL_BUSY});
            if(__DEV__) {
                dispatch( {
                    type: PROPOSAL_SAVED,
                    payload: proposal,
                });
                resolve(proposal);
            } else {
                window.SP.SOD.executeFunc("sp.js", "SP.ClientContext", () => {
                    let ctx = window.SP.ClientContext.get_current();
                    addExecuteQuery();
                    let sharepointItem;
                    let clientContact = null;
                    let itContact = null;

                    if(proposal.GeneralData.ClientContact && proposal.GeneralData.ClientContact.key) {
                        clientContact = ctx.get_web().ensureUser(proposal.GeneralData.ClientContact.key);
                        ctx.load(clientContact, 'Id');
                    }
                    if(proposal.GeneralData.ItContact && proposal.GeneralData.ItContact.key) {
                        itContact = ctx.get_web().ensureUser(proposal.GeneralData.ItContact.key);
                        ctx.load(itContact, 'Id');
                    }
                    ctx.executeQuery()
                    .then( () => {
                        //Calculate scores if there are none.
                        if( proposal.BenefitAverage === null || proposal.ScopeAverage === null || proposal.RiskAverage === null || proposal.StrategyAverage || null ) {
                            calculateAverages(proposal);
                        }
                        if(proposal.Id && proposal.Id !== null) {
                            sharepointItem = ctx.get_web().getList(window._spPageContextInfo.webAbsoluteUrl + "/Lists/Endringsforslag").getItemById(proposal.Id);
                            returnType = PROPOSAL_SAVED;
                        } else {
                            sharepointItem = ctx.get_web().getList(window._spPageContextInfo.webAbsoluteUrl + "/Lists/Endringsforslag").addItem(new window.SP.ListItemCreationInformation());
                            returnType = PROPOSAL_CREATED;
                        }
                        updateSharepointProposalObject(proposal, sharepointItem, clientContact, itContact);
                        sharepointItem.update();
                        ctx.load(sharepointItem, 'Id');
                        return ctx.executeQuery().then( () => {
                            let retItem = {...proposal};
                            retItem.Id = sharepointItem.get_id();
                            return retItem;
                        });
                    })
                    .then( (props) => {
                        dispatch( {
                            type: returnType,
                            payload: props,
                        });
                        resolve(props);
                    })
                    .catch((sender, args) => {
                        dispatch({
                            type: PROPOSAL_ERROR,
                            payload: `Error saving proposal ${args && args.get_message() || ''}`,
                        });
                        reject(new Error(`Error saving proposal ${args && args.get_message() || ''}`));
                    });
                });
            }
        });
    };
}

export function saveProcessedData(proposal) {
    return (dispatch) => {
        if (proposal.ProcessedDate === null) {
            proposal.ProcessedDate = moment().format('DD/MM/YYYY');
        }
        if (proposal.ProposedStart === null) {
            proposal.ProposedStart = moment().format('DD/MM/YYYY');
        }

        return dispatch(saveProposalData(proposal))
        .then(() => {
            let returnType = '';
            dispatch({type: PROPOSAL_BUSY});
            if(__DEV__) {
                return dispatch( {
                    type: PROPOSAL_SAVED,
                    payload: proposal,
                });
            } else {
                window.SP.SOD.executeFunc("sp.js", "SP.ClientContext", () => {
                    let ctx = window.SP.ClientContext.get_current();
                    addExecuteQuery();
                    let sharepointItem;
                    let responsible = null;

                    if (proposal.Responsible && proposal.Responsible.key) {
                        responsible = ctx.get_web().ensureUser(proposal.Responsible.key);
                        ctx.load(responsible, "Id");
                    }
                    ctx.executeQuery()
                    .then( () => {
                        if(proposal.Id) {
                            sharepointItem = ctx.get_web().getList(window._spPageContextInfo.webAbsoluteUrl + "/Lists/Endringsforslag").getItemById(proposal.Id);
                            returnType = PROPOSAL_SAVED;
                        }
                        updateSharepointProcessedObject(proposal, sharepointItem, responsible);
                        sharepointItem.update();
                        ctx.load(sharepointItem, 'Id');
                        return ctx.executeQuery().then( () => {
                            let retItem = {...proposal};
                            retItem.Id = sharepointItem.get_id();
                            return retItem;
                        });
                    })
                    .then( (props) => {
                        return dispatch( {
                            type: returnType,
                            payload: props,
                        });
                    });
                });
            }
        })
        .catch((err) => {
            console.log(err);
        });
    };
}

export function getProposalList() {
    return (dispatch) => {
        dispatch( {type: PROPOSAL_BUSY});
        if(__DEV__) {
            return dispatch({
                type: PROPOSAL_LIST_RETRIEVED,
                payload: require('../mock/proposals.json'),
            });
        }

        getList('Endringsforslag', {
            fields: [
                'Id',
                'Title',
                'Created',
                'Author',
                'Status1',
                'TotalScore',
                'Endringsportefolje',
                'Palagt1',
                'KontaktpersonKunde',
                'Ansvarlig',
                'Prosjektrom',
                'Forvaltningsomrade',
            ],
            mapper: (item) => {
                // ChangePortfolio changed from number to string - temporary backwards comp.
                let changePortfolio = item.get_item('Endringsportefolje') || null;
                if (parseInt(changePortfolio, 10) >= 0) {
                    switch (changePortfolio) {
                        case "0":
                        changePortfolio = "";
                        break;
                        case "1":
                        changePortfolio = "Driftsoppgave";
                        break;
                        case "2":
                        changePortfolio = "Forvaltning";
                        break;
                        case "3":
                        changePortfolio = "Fast-Track";
                        break;
                        case "4":
                        changePortfolio = "Prosjekt";
                        break;
                        case "5":
                        changePortfolio = "Oppdrag";
                        break;
                        case "6":
                        changePortfolio = "Satt på vent";
                        break;
                        case "7":
                        changePortfolio = "Forslag ikke videreført som egen aktivitet";
                        break;
                        case "8":
                        changePortfolio = "Avventer beslutning IT-styre/Ledermøte";
                        break;
                    }
                }
                // Status changed from number to string - temporary backwards comp.
                let status = item.get_item('Status1') || "Under utfylling";
                if (parseInt(status, 10) >= 0) {
                    switch (status) {
                        case "0":
                        status = "Under utfylling";
                        break;
                        case "1":
                        status = "Til behandling";
                        break;
                        case "2":
                        status = "Under behandling";
                        break;
                        case "3":
                        status = "Ferdig behandlet";
                        break;
                    }
                }
                const obj = {};
                let statusCode = statusCodeMap[status];
                obj.Id = item.get_id();
                obj.Title = item.get_item('Title') || '';
                obj.Status1 = status;
                obj.statusCode = statusCode;
                obj.AverageScore = item.get_item('TotalScore') || '';
                obj.Created = item.get_item('Created') && moment(item.get_item('Created')).format('YYYY-MM-DD') || '';
                obj.CreatedBy = item.get_item('Author').get_email() || '';
                obj.Author = item.get_item('Author').get_lookupValue() || '';
                obj.Endringsportefolje = changePortfolio;
                obj.Required1 = item.get_item('Palagt1') || '';
                obj.ClientContact = item.get_item('KontaktpersonKunde') && item.get_item('KontaktpersonKunde').get_lookupValue();
                obj.Responsible = item.get_item('Ansvarlig') && item.get_item('Ansvarlig').get_lookupValue() || '';
                obj.ProjectRoom = item.get_item('Prosjektrom') && item.get_item('Prosjektrom').get_url() || '';
                obj.AdminArea = item.get_item('Forvaltningsomrade') || '';
                return obj;
            },
        })
        .then((result) => {
            dispatch( {
                type: PROPOSAL_LIST_RETRIEVED,
                payload: result,
            });
        })
        .catch((sender, args) => {
            dispatch( {
                type: PROPOSAL_ERROR,
                payload: `Error getting proposal list ${args && args.get_message() || ''}`,
            });
        });
    };
}


export function getProposal(proposalId) {
    return (dispatch) => {
        dispatch({ type: PROPOSAL_BUSY });
        if(!proposalId || proposalId === null) {
            let GeneralData = {
                Title: '',
                DescriptionOfNeed: '',
                Benefit: '',
                Scope: '',
                Risk: '',
                Strategic: '',
                MainAdmin: '',
                ClientContact: null,
                ItContact: null,
                MainUser: '',
            };
            let defaultItem = {
                Author: '',
                GeneralData: GeneralData,
                Scope1: "-1",
                Scope2: "-1",
                Scope3: "-1",
                Scope4: "-1",
                FastTrack: '-1',
                F_Reason: '',
                P_Reason: '',
                RequiredBy: '',
                ProcessedForum: '',
                ProcessedDate: null,
                ProcessedSummary: '',
                OtherFinancing: '',
                ChangePortfolio: "-1",
                ProgramPortfolio: "-1",
                PortfolioNr: '',
                Responsible: null,
                ProjectRoom: '',
                ProposedStart: null,
                ProcessedCompleted: "-1",
                Strategy1: "-1",
                Strategy2: "-1",
                Strategy3: "-1",
                Strategy4: "-1",
                Strategy5: "-1",
                Benefit1: "-1",
                Benefit2: "-1",
                Benefit3: "-1",
                Benefit4: "-1",
                Risk1: "-1",
                Risk2: "-1",
                Risk3: "-1",
                Risk4: "-1",
                Required1: "-1",
                Status1: "Under utfylling",
                Financing1: "",
                ModifiedBy: null,
                AverageScore: '-1',
                Id: null,
                Attachments: [],
                Forvaltningsomrade: null,
            };

            return dispatch( {
                type: PROPOSAL_RETRIEVED,
                payload: defaultItem,
            });
        }

        if(__DEV__) {
            return dispatch({
                type: PROPOSAL_RETRIEVED,
                payload: require('../mock/proposal.json'),
            });
        }

        // try to make sure taxonomy works
        window.SP.SOD.executeFunc("sp.js", "SP.ClientContext", () => {
            window.SP.SOD.registerSod('sp.taxonomy.js', window.SP.Utilities.Utility.getLayoutsPageUrl('sp.taxonomy.js'));
            window.SP.SOD.executeFunc('sp.taxonomy.js', false, Function.createDelegate(this, function () {
            }));
        });

        getItem('Endringsforslag', proposalId, {
            attachments: true,
            mapper: (item) => {
                // Financing changed from number to string - temporary backwards comp.
                let financing = item.get_item('Finansiering1') || null;
                if (parseInt(financing, 10) >= 0) {
                    switch (financing) {
                        case "0":
                        financing = "Forvaltningsbudsjett";
                        break;
                        case "1":
                        financing = "Endringsbudsjett";
                        break;
                        case "2":
                        financing = "Fast-track";
                        break;
                        case "3":
                        financing = "SO";
                        break;
                        case "4":
                        financing = "Annen";
                        break;
                    }
                }

                // ChangePortfolio changed from number to string - temporary backwards comp.
                let changePortfolio = item.get_item('Endringsportefolje') || null;
                if (parseInt(changePortfolio, 10) >= 0) {
                    switch (changePortfolio) {
                        case "0":
                        changePortfolio = "";
                        break;
                        case "1":
                        changePortfolio = "Driftsoppgave";
                        break;
                        case "2":
                        changePortfolio = "Forvaltning";
                        break;
                        case "3":
                        changePortfolio = "Fast-Track";
                        break;
                        case "4":
                        changePortfolio = "Prosjekt";
                        break;
                        case "5":
                        changePortfolio = "Oppdrag";
                        break;
                        case "6":
                        changePortfolio = "Satt på vent";
                        break;
                        case "7":
                        changePortfolio = "Forslag ikke videreført som egen aktivitet";
                        break;
                        case "8":
                        changePortfolio = "Avventer beslutning IT-styre/Ledermøte";
                        break;
                    }
                }

                // Status changed from number to string - temporary backwards comp.
                let status = item.get_item('Status1') || "Under utfylling";
                if (parseInt(status, 10) >= 0) {
                    switch (status) {
                        case "0":
                        status = "Under utfylling";
                        break;
                        case "1":
                        status = "Til behandling";
                        break;
                        case "2":
                        status = "Under behandling";
                        break;
                        case "3":
                        status = "Ferdig behandlet";
                        break;
                    }
                }
                
                //Must be stored as Number to ble Excel compliant and represented as String in UI for choicefields.
                let required =  item.get_item('Palagt1') || null;
                if (required !== null ){
                    required = required.toFixed(2).toString();
                }

                return {
                    Id: item.get_id(),
                    Author: item.get_item('Author').get_email() || '',
                    Scope1: item.get_item('O_Omfang1') || null,
                    Scope2: item.get_item('Omfang2') || null,
                    Scope3: item.get_item('O_Omfang3') || null,
                    Scope4: item.get_item('Omfang4') || null,
                    FastTrack: item.get_item('FastTrack') || null,
                    F_Reason: item.get_item('F_Begrunnelse') || '',
                    P_Reason: item.get_item('P_Begrunnelse') || '',
                    RequiredBy: item.get_item('P_PalagtAv') || null,
                    ProcessedForum: item.get_item('ForaBehandlet') || '',
                    ProcessedDate: item.get_item('DatoBehandlet') ? item.get_item('DatoBehandlet'): null,
                    ProcessedSummary: item.get_item('OppsummeringBehandlet') || '',
                    OtherFinancing: item.get_item('FinansieringAnnet') || '',
                    ChangePortfolio: changePortfolio,
                    ProgramPortfolio: item.get_item('Programportefolje') || null,
                    PortfolioNr: item.get_item('ProsjektportefoljeNr') || '',
                    Responsible: item.get_item('Ansvarlig') && {
                        key: item.get_item('Ansvarlig').get_email(),
                        text: item.get_item('Ansvarlig').get_lookupValue(),
                        avatar: getAvatarUrlByEmail(item.get_item('Ansvarlig').get_email()),
                    }  || null,
                    ProjectRoom: item.get_item('Prosjektrom') && item.get_item('Prosjektrom').get_url() || '',
                    ProposedStart: item.get_item('ForslagOppstart') || null,
                    ProcessedCompleted: item.get_item('FerdigBehandlet') || null,
                    Strategy1: item.get_item('Strategi1') || null,
                    Strategy2: item.get_item('Strategi2') || null,
                    Strategy3: item.get_item('Strategi3') || null,
                    Strategy4: item.get_item('Strategi4') || null,
                    Strategy5: item.get_item('Strategi5') || null,
                    Benefit1: item.get_item('Nytte1') || null,
                    Benefit2: item.get_item('Nytte2') || null,
                    Benefit3: item.get_item('Nytte3') || null,
                    Benefit4: item.get_item('Nytte4') || null,
                    Risk1: item.get_item('Risiko1') || null,
                    Risk2: item.get_item('Risiko2') || null,
                    Risk3: item.get_item('Risiko3') || null,
                    Risk4: item.get_item('Risiko4') || null,
                    Required1: required,
                    Status1: status,
                    statusCode: statusCodeMap[status],
                    Financing1: financing,
                    AdminArea: item.get_item('Forvaltningsomrade') || null,
                    ModifiedBy: item.get_item('Editor') && {
                        key: item.get_item('Editor').get_email(),
                        text: item.get_item('Editor').get_lookupValue(),
                        avatar: getAvatarUrlByEmail(item.get_item('Editor').get_email()),
                    }  || null,
                    AverageScore: item.get_item('TotalScore') || '',
                    Attachments: item.get_attachmentFiles().get_data().map((file) => file.get_fileName()) || [],
                    GeneralData: {
                        Title: item.get_item('Title') || '',
                        DescriptionOfNeed: item.get_item('BeskrivelseAvBehov') || '',
                        Benefit: item.get_item('Nytteverdi') || '',
                        Scope: item.get_item('Omfang') || '',
                        Risk: item.get_item('Risiko') || '',
                        Strategic: item.get_item('Strategisk') || '',
                        ClientContact: item.get_item('KontaktpersonKunde') && {
                            key: item.get_item('KontaktpersonKunde').get_email(),
                            text: item.get_item('KontaktpersonKunde').get_lookupValue(),
                            avatar: getAvatarUrlByEmail(item.get_item('KontaktpersonKunde').get_email()),
                        }  || null,
                        ItContact: item.get_item('KontaktpersonIT') && {
                            key: item.get_item('KontaktpersonIT').get_email(),
                            text: item.get_item('KontaktpersonIT').get_lookupValue(),
                            avatar: getAvatarUrlByEmail(item.get_item('KontaktpersonIT').get_email()),
                        } ||  null,
                        MainUser: item.get_item('Hovedbruker') || '',
                        MainAdmin: item.get_item('Forvalter') && item.get_item('Forvalter').get_termGuid() || '',
                    },
                };
            },
        })
        .then((item) => {
            dispatch({
                type: PROPOSAL_RETRIEVED,
                payload: item,
            });
        })
        .catch((sender, args) => {
            return dispatch({
                type: PROPOSAL_ERROR,
                payload: `Error getting research application data ${args && args.get_message() || ''}`,
            });
        });
    };
}

export function clearProposal() {
    return { type: PROPOSAL_CLEAR };
}

function updateSharepointProposalObject(proposal, sharepointItem, clientContact, itContact) {
    sharepointItem.set_item('Title', proposal.GeneralData.Title);
    sharepointItem.set_item('BeskrivelseAvBehov', proposal.GeneralData.DescriptionOfNeed);
    sharepointItem.set_item('Nytteverdi', proposal.GeneralData.Benefit);
    sharepointItem.set_item('Omfang', proposal.GeneralData.Scope);
    sharepointItem.set_item('Risiko', proposal.GeneralData.Risk);
    sharepointItem.set_item('Strategisk', proposal.GeneralData.Strategic);
    if(proposal.GeneralData.MainAdmin) {
        let mainAdmin = new window.SP.Taxonomy.TaxonomyFieldValue();
        mainAdmin.set_termGuid(proposal.GeneralData.MainAdmin);
        mainAdmin.set_wssId(-1);
        sharepointItem.set_item('Forvalter', mainAdmin);
    }
    if(clientContact) {
        sharepointItem.set_item('KontaktpersonKunde', clientContact.get_id());
    }
    if(itContact) {
        sharepointItem.set_item('KontaktpersonIT', itContact.get_id());
    }
    if( proposal.Status1 === null || proposal.Status1)
    sharepointItem.set_item('Forvaltningsomrade', proposal.AdminArea);
    sharepointItem.set_item('Hovedbruker', proposal.GeneralData.MainUser);
    sharepointItem.set_item('O_Omfang1', proposal.Scope1);
    sharepointItem.set_item('Omfang2', proposal.Scope2);
    sharepointItem.set_item('O_Omfang3', proposal.Scope3);
    sharepointItem.set_item('Omfang4', proposal.Scope4);
    sharepointItem.set_item('O_Snittscore', proposal.ScopeAverage);
    sharepointItem.set_item('FastTrack', proposal.FastTrack);
    sharepointItem.set_item('F_Begrunnelse', proposal.F_Reason);
    sharepointItem.set_item('P_Begrunnelse', proposal.P_Reason);
    sharepointItem.set_item('P_PalagtAv', proposal.RequiredBy);
    sharepointItem.set_item('Strategi1', proposal.Strategy1);
    sharepointItem.set_item('Strategi2', proposal.Strategy2);
    sharepointItem.set_item('Strategi3', proposal.Strategy3);
    sharepointItem.set_item('Strategi4', proposal.Strategy4);
    sharepointItem.set_item('Strategi5', proposal.Strategy5);
    sharepointItem.set_item('S_Snittscore', proposal.StrategyAverage);
    sharepointItem.set_item('Nytte1', proposal.Benefit1);
    sharepointItem.set_item('Nytte2', proposal.Benefit2);
    sharepointItem.set_item('Nytte3', proposal.Benefit3);
    sharepointItem.set_item('Nytte4', proposal.Benefit4);
    sharepointItem.set_item('N_Snittscore', proposal.BenefitAverage);
    sharepointItem.set_item('Risiko1', proposal.Risk1);
    sharepointItem.set_item('Risiko2', proposal.Risk2);
    sharepointItem.set_item('Risiko3', proposal.Risk3);
    sharepointItem.set_item('Risiko4', proposal.Risk4);
    sharepointItem.set_item('R_Snittscore', proposal.RiskAverage);
    sharepointItem.set_item('Palagt1', proposal.Required1);
    sharepointItem.set_item('TotalScore', proposal.AverageScore);
}

function updateSharepointProcessedObject(proposal, sharepointItem, responsibleUser) {
    sharepointItem.set_item('ForaBehandlet', proposal.ProcessedForum);
    sharepointItem.set_item('DatoBehandlet', moment(proposal.ProcessedDate, 'DD/MM/YYYY').toDate());
    sharepointItem.set_item('OppsummeringBehandlet', proposal.ProcessedSummary);
    sharepointItem.set_item('FinansieringAnnet', proposal.OtherFinancing);
    sharepointItem.set_item('Endringsportefolje', proposal.ChangePortfolio);
    sharepointItem.set_item('Programportefolje', proposal.ProgramPortfolio);
    sharepointItem.set_item('ProsjektportefoljeNr', proposal.PortfolioNr);
    if(responsibleUser) {
        sharepointItem.set_item('Ansvarlig', responsibleUser.get_id());
    }
    sharepointItem.set_item('Status1', proposal.Status1);
    sharepointItem.set_item('Finansiering1', proposal.Financing1);
    sharepointItem.set_item('ForslagOppstart', moment(proposal.ProposedStart, 'DD/MM/YYYY').toDate());
    sharepointItem.set_item('FerdigBehandlet', proposal.ProcessedCompleted);

    if (proposal.ProjectRoom.indexOf('http') === -1) {
        proposal.ProjectRoom = '';
    }
    sharepointItem.set_item('Prosjektrom', proposal.ProjectRoom);
}


export function sendForProcessing(proposal) {
    return (dispatch) => {
        dispatch({ type: PROPOSAL_BUSY });
        return dispatch(saveProposalData(proposal))
        .then(() => {
            if (!__DEV__) {
                window.SP.SOD.executeFunc("sp.js", "SP.ClientContext", () => {
                    let ctx = window.SP.ClientContext.get_current();
                    addExecuteQuery();
                    let item = ctx.get_web().getList(window._spPageContextInfo.webAbsoluteUrl + "/Lists/Endringsforslag").getItemById(proposal.Id);
                    item.set_item(PROPOSAL_STATUS_FIELD_NAME, TIL_BEHANDLING_CODE);
                    item.update();
                    ctx.executeQuery();
                });
                const subject = 'Prosjekt forslag er klar for behandling';
                const deepLink = `${window.location.origin}${window.location.pathname}?r=/edit/${proposal.Id}`;
                const body = `
En bruker ønsker at du ser over et prosjektforslag.
Du kan se over søknaden her; <a href="${deepLink}">${deepLink}</a>

A user would like you to review their project proposal.
You can review the application here; <a href="${deepLink}">${deepLink}</a>
                `;

                const from = 'no-reply@sharepoint.com';
                const to = [];
                //to.push('prosjektkontoret@it.ntnu.no');
                to.push('ole.einar.brakken@ntnu.no');

                const siteurl = window._spPageContextInfo.webServerRelativeUrl;
                const urlTemplate = siteurl + "/_api/SP.Utilities.Utility.SendEmail";

                const requestDigest = document.getElementById('__REQUESTDIGEST').value;
                fetch(urlTemplate, {
                    credentials: 'same-origin',
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json;odata=verbose',
                        'Content-Type': 'application/json;odata=verbose',
                        'X-RequestDigest': requestDigest,
                    },
                    body: JSON.stringify({
                        'properties': {
                            '__metadata': { 'type': 'SP.Utilities.EmailProperties' },
                            'From': from,
                            'To': { 'results': to },
                            'Body': body,
                            'Subject': subject,
                        },
                    }),
                }).then(respToJson)
                .then((json) => {
                    return dispatch({
                        type: TIL_BEHANDLING_STATUS,
                        payload: json,
                    });
                })
                .catch((sender, err) => {
                    return dispatch({
                        type: EMAIL_ERROR,
                        payload: `Error sending email. ${err && err.get_message() || ''}`,
                    });
                });
            }
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/proposalAction.js